import useNotification from 'antd/es/notification/useNotification';
import React, { createContext, useContext } from 'react';

/**
 * Контекст для глобальных уведомлений.
 * @type {React.Context<[notify: import('antd/es/notification/interface.d.ts').NotificationInstance, contextHolder: React.ReactNode]>}
 */
const NotificationContext = createContext(undefined);

/**
 * Хук для доступа к глобальному уведомлению.
 * @returns {[notify: import('antd/es/notification/interface.d.ts').NotificationInstance, contextHolder: React.ReactNode]>}}
 * @throws {Error} Если хук используется вне NotificationProvider.
 */
export const useGlobalNotification = () => {
    const ctx = useContext(NotificationContext);
    if (!ctx) throw new Error('useGlobalNotification must be used within NotificationProvider');
    return ctx;
};

/**
 * Провайдер для глобальных уведомлений.
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @returns {React.ReactElement}
 */
export function NotificationProvider({ children }) {
    const [notify, contextHolder] = useNotification();
    return (
        <NotificationContext.Provider value={[notify, contextHolder]}>
            {contextHolder}
            {children}
        </NotificationContext.Provider>
    );
}
